import { Grid, Typography, styled } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React, { memo } from 'react';
import Modal from '../common/Modal';
import { notifySuccess } from '../utils/Utils';

export const DealerInviteCode = memo(({ onClose, isOpen, inviteCode }) => {
  const handleInvite = () => {
    navigator.clipboard.writeText(inviteCode);
    notifySuccess('Dealer Invite Code copied to clipboard.');
  };
  return (
    <Modal isOpen={isOpen} closePopup={onClose} width="33vw" height="232px" padding="0px">
      <Div container>
        <Grid item xs={12}>
          <TopBar container justifyContent="space-between">
            <Grid item>
              <Title>Invite Code </Title>
            </Grid>
            <Grid item>
              <Title onClick={onClose}>
                <CloseIcon style={{ cursor: 'pointer' }} />
              </Title>
            </Grid>
          </TopBar>
        </Grid>
        <MainContainer item>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <SubTitleText>Dealership invite code</SubTitleText>
            </Grid>
            <Grid item xs={12}>
              <HintText>Share this invite code for users onboarding with personal email</HintText>
            </Grid>
          </Grid>
          <CodeContainer item xs={12}>
            <Grid container justifyContent="space-between" alignItems="center">
              <Grid item>
                <CodeText>{inviteCode}</CodeText>
              </Grid>
              <Grid item>
                <Btn container onClick={handleInvite}>
                  <StyledTypography>Copy Code</StyledTypography>
                </Btn>
              </Grid>
            </Grid>
          </CodeContainer>
        </MainContainer>
      </Div>
    </Modal>
  );
});

const Div = styled(Grid)``;

const TopBar = styled(Grid)`
  padding: 15px 20px;
  background: white;
`;

const MainContainer = styled(Grid)`
  width: 100%;
  padding: 20px;
  background-color: #f2f4f7;
`;

const Title = styled(Typography)`
  font-size: 22px !important;
  font-weight: 600;
`;

const SubTitleText = styled(Typography)`
  font-weight: 700;
  font-style: Bold;
  font-size: 16px !important;
  line-height: 140%;
  color: #10182b;
`;

const HintText = styled(Typography)`
  font-weight: 500;
  font-style: Medium;
  font-size: 12px !important;
  line-height: 140%;
  color: #667085;
`;

const StyledTypography = styled(Typography)`
  font-weight: 600;
  font-size: 14px !important;
  color: #622fee;
`;

const CodeText = styled(Typography)`
  font-weight: 400;
  font-size: 16px !important;
  color: #667085;
`;

const CodeContainer = styled(Grid)`
  padding: 12px 16px;
  gap: 12px;
  border-radius: 12px;
  background-color: #fefefe;
  margin-top: 16px !important;
`;
const Btn = styled(Grid)`
  opacity: 1;
  padding: 6px 16px;
  gap: 4px;
  border-radius: 100px;
  border-width: 1px;
  border: 1px solid #e4e7ec;
  background: transparent;
  cursor: pointer;
`;
